import React from "react";
import { Modal } from "reactstrap";
import PropTypes from "prop-types";
import CommonButton from "../buttons/CommonButton";

/**
 * Componente CommonModal
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do corpo modal.
 * @param {string} props.title - O título do modal.
 * @param {boolean} props.is_open_modal - Um sinalizador que indica se o modal está aberto ou fechado.
 * @param {Function} props.set_is_open_modal - A função para alternar o modal aberto ou fechado.
 * @param {("sm"|"md"|"lg"|"xl")} props.size - O tamanho do modal. Deve ser um de ["sm", "md", "lg", "xl"].
 * @param {ReactNode} [props.buttons=null] - Botões adicionais a serem renderizados no rodapé modal.
 * @param {Function} [props.customDeny=null] - Um botão opcional a ser exibido no lugar do botão de cancelar padrão.
 * @returns {ReactElement} O elemento React renderizado que representa o modal.
 */
function CommonModal({
  children,
  title,
  is_open_modal,
  set_is_open_modal,
  size,
  buttons = null,
  customDeny = null,
  customFooter = null,
}) {
  return (
    <Modal
      size={size}
      isOpen={is_open_modal}
      toggle={() => {
        set_is_open_modal(!is_open_modal);
      }}
      centered
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">{title}</h5>
        <button
          type="button"
          onClick={() => {
            set_is_open_modal(false);
          }}
          className="close btn-close"
          aria-label="Close"
        >
          <span style={{ color: "transparent" }} aria-hidden="true">
            &times;
          </span>
        </button>
      </div>
      <div className="modal-body">
        <React.Fragment>{children}</React.Fragment>
      </div>

      {customFooter ? (
        customFooter
      ) : (
        <div className="modal-footer">
          {buttons}
          {customDeny ? (
            customDeny
          ) : (
            <CommonButton
              onClick={() => {
                set_is_open_modal(false);
              }}
              color="danger"
            >
              Cancelar
            </CommonButton>
          )}
        </div>
      )}
    </Modal>
  );
}

CommonModal.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  is_open_modal: PropTypes.bool.isRequired,
  set_is_open_modal: PropTypes.func.isRequired,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl"]).isRequired,
  buttons: PropTypes.node.isRequired,
  customDeny: PropTypes.node,
  customFooter: PropTypes.node,
};

export default CommonModal;
